import cloneDeep from 'lodash-es/cloneDeep'

import { sleep } from '../../utils/async'

const CALENDAR_SETTINGS_MOCK_LATENCY = 400

const CALENDAR_SETTINGS_MOCK_STATE = {
  daily_followup_limit: 10,
  show_provider_tasks: false,
  task_types: [
    {
      calendar_relevant: true,
      id: 16,
      name: 'Book the technician',
      used_by_template: false,
    },
    {
      calendar_relevant: false,
      id: 14,
      name: 'Documentation',
      used_by_template: true,
    },
    {
      calendar_relevant: false,
      id: 15,
      name: 'Get a quote',
      used_by_template: true,
    },
    {
      calendar_relevant: false,
      id: 13,
      name: 'Invoice check',
      used_by_template: true,
    },
    {
      calendar_relevant: true,
      id: 11,
      name: 'On-site visit',
      used_by_template: false,
    },
    {
      calendar_relevant: true,
      id: 12,
      name: 'Owner approval',
      used_by_template: false,
    },
  ],
  timezone: 'Europe/Vienna',
}

export function getMockCalendarSettings() {
  return sleep(CALENDAR_SETTINGS_MOCK_LATENCY).then(() => ({
    data: cloneDeep(CALENDAR_SETTINGS_MOCK_STATE),
  }))
}

export function updateMockCalendarSettings(payload) {
  return sleep(CALENDAR_SETTINGS_MOCK_LATENCY).then(() => {
    Object.assign(CALENDAR_SETTINGS_MOCK_STATE, cloneDeep(payload))

    return { data: cloneDeep(CALENDAR_SETTINGS_MOCK_STATE) }
  })
}
